import { Divider } from "@mui/material";
import { arSD } from "@mui/material/locale";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import { faIR } from "@mui/x-date-pickers/locales";
import { useMemo } from "react";
import { ClockLoader } from "react-spinners";
import { Empty } from "../Empty";
import { Pagination } from "../Pagination";
import RightToLeftLayout from "../RightToLeft";
import classes from "./style.module.scss";

export const Table = ({
  className = "",
  notFoundObjectName = "رکوردی",
  hiddenPagination = false,
  totalPages = 1,
  pageParamName = "page",
  loading = false,
  ...rest
}) => {
  const existingTheme = useTheme();
  const theme = useMemo(
    () =>
      createTheme(
        {
          overrides: {
            MUIDataTable: {
              responsiveStacked: {
                maxHeight: "none",
                overflowX: "auto",
              },
            },
          },
          direction: "rtl",
        },
        arSD,
        existingTheme,
        faIR
      ),
    [existingTheme]
  );

  return (
    <ThemeProvider theme={theme}>
      <RightToLeftLayout>
        <div className={`${classes.table} ${className}`}>
          {loading ? (
            <div className={classes.loadingBox}>
              <ClockLoader color={"#121f3e"} height={3} width={200} />
              صبر کنید...
            </div>
          ) : (rest?.rows?.length ?? 0) >= 1 ? (
            <>
              <DataGrid
                hideFooter
                disableColumnFilter
                disableColumnMenu
                disableColumnSelector
                disableRowSelectionOnClick
                filterMode="server"
                columnHeaderHeight={43}
                rowHeight={39}
                sx={{
                  border: "unset !important",
                  "& .MuiDataGrid-cell": {
                    border: "unset !important",
                  },
                }}
                {...rest}
              />

              {!hiddenPagination && (
                <>
                  <Divider /> <Pagination count={totalPages} pageParamName={pageParamName} />
                </>
              )}
            </>
          ) : (
            <Empty objectName={notFoundObjectName} />
          )}
        </div>
      </RightToLeftLayout>
    </ThemeProvider>
  );
};
